/**
 *  Table script file
**/

export default {
  name: 'Table',
  mixins: [],
  components: {},
  props: {
    items: {
      type: Array
    },
    totalItems: {
      type: Number
    },
    remote: {
      type: Boolean,
      default: false
    },
    visibleColumns: {
      type: Array,
      required: false
    },
    columNames: {
      type: Array,
      required: false
    },
    filter: {
      type: Boolean,
      default: false,
      required: false
    },
    indexes: {
      type: Boolean,
      default: false,
      required: false
    },
    sortColumns: {
      type: Boolean,
      default: true,
      required: false
    },
    selectable: {
      type: Boolean,
      default: true,
      required: false
    },
    nodataMessage: {
      type: String,
      default: 'No data.',
      required: false
    },
    currentPage: {
      type: Number,
      default: 1
    },
    pagination: {
      type: Boolean,
      default: false,
      required: false
    },
    itemsPerPage: {
      type: Number,
      default: Infinity,
      required: false
    },
    paginationPlaceholder: {
      type: String,
      default: 'elements',
      required: false
    },
    paginationInputPlaceholder: {
      type: String,
      default: 'go to',
      required: false
    }
  },
  data () {
    return {
      cached: [],
      page: [],
      descendent: true,
      nodata: false
    }
  },
  computed: {
    nItems () {
      return this.remote ? this.totalItems : this.items.length
    },
    columns () {
      return this.visibleColumns ? this.visibleColumns : this.items ? Object.keys(this.items[0]) : []
    },
    getRowClass () {
      return {
        'selectable': this.selectable
      }
    }
  },
  mounted () {
    this.setItems()
    if (this.$refs.paginationComponent) {
      this.$refs.paginationComponent.setPage(1, false)
    }
  },
  methods: {
    setItems () {
      this.cached = this.items
      this.page = this.items.slice(0, this.itemsPerPage)
    },
    hasSlot (name = 'default') {
      return !!this.$slots[name] || !!this.$scopedSlots[name]
    },
    tableRowClick (col) {
      if (this.selectable) {
        const selected = Object.assign({}, col)
        this.setSelected(selected)
        this.$emit('select', selected)
      }
    },
    setSelected (selected) {
      const data = this.items.map(i => {
        if (i.id === selected.id) {
          i.selected = true
        } else {
          i.selected = false
        }
        return i
      })
      this.page = data
    },
    sortTable (column, event) {
      event.preventDefault()
      event.stopPropagation()

      if (this.sortColumns) {
        this.setSelectedHeader(event.target)
        this.cached.sort(this.sortByProp(column))
      }
    },
    setSelectedHeader (target) {
      const headerCells = this.$el.querySelectorAll('.table-header .table-cell')
      headerCells.forEach(cell => {
        if (cell === target) {
          if (cell.classList.contains('selected')) {
            this.descendent = !this.descendent
            cell.classList.toggle('order')
          } else {
            this.descendent = true
            cell.classList.add('selected')
          }
        } else {
          cell.classList.remove('selected')
          cell.classList.remove('order')
        }
      })
    },
    sortByProp (prop) {
      return (a, b) => {
        if (this.descendent === false) {
          return b[prop].localeCompare(a[prop])
        } else {
          return a[prop].localeCompare(b[prop])
        }
      }
    },
    filterTable (event) {
      const inputValue = event.target.value
      const data = this.items.filter((item) =>
        Object.values(item).map((value) => String(value)).find((value) =>
          value.toLowerCase().includes(inputValue.toLowerCase())))

      this.nodata = !data.length
      this.cached = data
      this.page = data
    },
    onChangePage (pager) {
      if (this.remote) {
        this.$emit('changePage', pager)
      } else {
        const items = this.items.slice(pager.startIndex, pager.endIndex + 1)
        this.page = items
      }
    }
  },
  watch: {
    items (value) {
      this.items = value
      this.setItems()
    },
    visibleColumns (value) {
      this.visibleColumns = value
      this.setItems()
    },
    customStyle () {
      this.getStyle()
    }
  },
  filters: {
    normalizeHeaders (value) {
      return value.replace(/-/g, ' ')
    }
  }
}
